module.exports = __webpack_public_path__ + "img/scbelement.0b60e8ba.webp";